import { Badge } from "@/components/ui/badge";

const MAP = {
  // environment classification
  TEST: ["#FCD34D", "#B45309", "#451A03"],
  QA: ["#67E8F9", "#0891B2", "#083344"],
  MIGRATION: ["#F0ABFC", "#9333EA", "#3B0764"],
  ARCHIVED: ["#94A3B8", "#334155", "#1E293B"],
  SUCCEEDED: ["#6EE7B7", "#10B981", "#064E3B"],
  FAILED: ["#FCA5A5", "#DC2626", "#450A0A"],
  BLOCKED: ["#FCA5A5", "#B91C1C", "#450A0A"],
  BUDGET_EXCEEDED: ["#FDBA74", "#EA580C", "#431407"],
  AVAILABLE: ["#6EE7B7", "#10B981", "#064E3B"],
  MISSING: ["#94A3B8", "#334155", "#1E293B"],
  NEEDS_REVIEW: ["#FBBF24", "#B45309", "#451A03"],
  NEEDS_FOUNDER_INPUT: ["#FB7185", "#BE123C", "#4C0519"],
  PROMOTED: ["#6EE7B7", "#10B981", "#064E3B"],
  PREPARED: ["#60A5FA", "#1E40AF", "#172554"],
  NOT_READY: ["#FBBF24", "#B45309", "#451A03"],
  READY_FOR_PROCESSING: ["#6EE7B7", "#10B981", "#064E3B"],
  DEGRADED: ["#FCD34D", "#B45309", "#451A03"],
  RATE_LIMITED: ["#FCD34D", "#B45309", "#451A03"],
  DOWN: ["#FCA5A5", "#DC2626", "#450A0A"],
  T0: ["#93C5FD", "#2563EB", "#0B1E3B"],
  T1: ["#93C5FD", "#2563EB", "#0B1E3B"],
  T2: ["#FCD34D", "#B45309", "#451A03"],
  T3: ["#FDBA74", "#EA580C", "#431407"],
  T4: ["#FCA5A5", "#DC2626", "#450A0A"],
  // mission
  DRAFT: ["#94A3B8", "#334155", "#1E293B"],
  BACKLOG: ["#94A3B8", "#334155", "#1E293B"],
  PLANNING: ["#60A5FA", "#1E40AF", "#172554"],
  READY: ["#34D399", "#047857", "#064E3B"],
  RUNNING: ["#38BDF8", "#0369A1", "#0C4A6E"],
  WAITING: ["#FBBF24", "#B45309", "#451A03"],
  REVIEW: ["#FBBF24", "#B45309", "#451A03"],
  APPROVAL_REQUIRED: ["#FB7185", "#BE123C", "#4C0519"],
  APPROVAL_PENDING: ["#FB7185", "#BE123C", "#4C0519"],
  COMPLETED: ["#6EE7B7", "#10B981", "#064E3B"],
  FAILED: ["#FCA5A5", "#DC2626", "#450A0A"],
  CANCELLED: ["#94A3B8", "#334155", "#1E293B"],
  REVISION: ["#FCD34D", "#D97706", "#3B2203"],
  BLOCKED: ["#FCA5A5", "#DC2626", "#450A0A"],
  QUEUED: ["#94A3B8", "#334155", "#1E293B"],
  RETRYING: ["#FCD34D", "#D97706", "#3B2203"],
  // agent availability
  ACTIVE: ["#6EE7B7", "#10B981", "#064E3B"],
  STANDBY: ["#94A3B8", "#334155", "#1E293B"],
  WORKING: ["#38BDF8", "#0369A1", "#0C4A6E"],
  ASSIGNED: ["#60A5FA", "#1E40AF", "#172554"],
  PAUSED: ["#94A3B8", "#334155", "#1E293B"],
  DISABLED: ["#64748B", "#334155", "#0F1626"],
  // approval classes
  A0: ["#34D399", "#059669", "#022C22"],
  A1: ["#38BDF8", "#0284C7", "#0B2E4C"],
  A2: ["#FCD34D", "#D97706", "#3B2203"],
  A3: ["#FCA5A5", "#DC2626", "#450A0A"],
  A4: ["#F0ABFC", "#9333EA", "#3B0764"],
  // approval status
  PENDING: ["#FB7185", "#BE123C", "#4C0519"],
  APPROVED: ["#6EE7B7", "#10B981", "#064E3B"],
  REJECTED: ["#FCA5A5", "#DC2626", "#450A0A"],
  // lock types
  FROZEN: ["#A5B4FC", "#4338CA", "#1E1B4B"],
  BRAND: ["#A5B4FC", "#4338CA", "#1E1B4B"],
  LEGAL: ["#F0ABFC", "#9333EA", "#3B0764"],
  COMPLIANCE: ["#FCD34D", "#D97706", "#3B2203"],
  OVERRIDE_APPROVED: ["#6EE7B7", "#10B981", "#064E3B"],
  UNRATED: ["#94A3B8", "#334155", "#1E293B"],
};

export function StatusPill({ status, className = "", label }) {
  const [text, border, bg] = MAP[status] || MAP.DRAFT;
  return (
    <span className={`m-pill ${className}`} style={{ color: text, borderColor: border, background: bg }} data-testid={`status-pill-${status}`}>
      {(label || status || "").replace(/_/g, " ")}
    </span>
  );
}

export function EnvBadge({ environment, archived }) {
  const isTestish = ["TEST", "QA", "MIGRATION"].includes(environment);
  if (!isTestish && !archived) return null;
  const key = isTestish ? environment : "ARCHIVED";
  const [text, border, bg] = MAP[key] || MAP.ARCHIVED;
  return (
    <span className="m-pill" style={{ color: text, borderColor: border, background: bg }} data-testid={`env-badge-${environment || "ARCHIVED"}`}>
      {environment === "MIGRATION" ? "REVIEW" : key}
    </span>
  );
}

export default StatusPill;
